<template>
  <div>
    <h2>Crear prospecto</h2>
    <el-form
      :model="model"
      :rules="rules"
      label-position="top"
      size="mini"
      ref="form"
      v-loading="loading_form"
    >
      <el-alert
        title="Recuerde crear el contacto al terminar de llenar este formulario"
        type="info"
        effect="dark"
      >
      </el-alert>
      <br />
      <el-row :gutter="10">
        <el-col :span="12">
          <el-card>
            <h3>Datos del prospecto</h3>

            <el-form-item label="Empresa" prop="MagycorpCompanyId">
              <el-input disabled v-model="model.MagycorpCompanyId"></el-input>
            </el-form-item>

            <!-- TODO: Esto debe salir solo cuando el rol lo amerite -->
            <el-form-item
              label="Vendedor"
              prop="SalesPersonCode"
              v-if="!isVendor"
            >
              <el-select
                v-model="model.SalesPersonCode"
                placeholder="Seleccionar Vendedor"
                @change="handleChangeSeller"
              >
                <el-option
                  v-for="item in sellersList"
                  :key="item.SalesPersonCode"
                  :value="item.SalesPersonCode"
                  :label="item.FullName"
                  :disabled="item.IsEnabled"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="RNC" prop="VatRegistrationNumber">
              <el-input v-model="model.VatRegistrationNumber"></el-input>
            </el-form-item>

            <el-form-item label="Nombre de compañia" prop="CompanyName">
              <el-input v-model="model.CompanyName"></el-input>
            </el-form-item>

            <el-form-item label="Dirección" prop="Address">
              <el-input v-model="model.Address"></el-input>
            </el-form-item>

            <el-form-item label="Ciudad" prop="City">
              <el-input v-model="model.City"></el-input>
            </el-form-item>
          </el-card>

          <el-col>
            <el-button-group>
              <el-button
                type="info"
                icon="el-icon-back"
                title="Cancelar y volver atras"
                @click="rollback"
                size="mini"
              ></el-button>
              <el-button
                type="success"
                icon="el-icon-check"
                @click="save"
                size="mini"
                >Guardar</el-button
              >
              <el-button type="warning" @click="reset" size="mini"
                >Resetear</el-button
              >
            </el-button-group>
          </el-col>
        </el-col>

        <el-col :span="12">
          <el-card>
            <h3>Datos del contacto</h3>

            <el-form-item label="Primer nombre" prop="FirstName">
              <el-input v-model="model.FirstName"></el-input>
            </el-form-item>

            <el-form-item label="Segundo nombre">
              <el-input v-model="model.MiddleName"></el-input>
            </el-form-item>

            <el-form-item label="Apellidos" prop="SurName">
              <el-input v-model="model.SurName"></el-input>
            </el-form-item>

            <el-form-item label="Puesto" prop="JobTitle">
              <el-input v-model="model.JobTitle"></el-input>
            </el-form-item>

            <el-form-item label="Número de teléfono" prop="PhoneNumber">
              <el-col :span="11">
                <el-input
                  v-model="model.PhoneNumber"
                  placeholder="Teléfono"
                ></el-input>
              </el-col>
              <el-col class="line" :span="2">-</el-col>
              <el-col :span="11">
                <el-input
                  v-model="model.ExtensionNumber"
                  placeholder="Extensión"
                ></el-input>
              </el-col>
            </el-form-item>

            <el-form-item label="Número de celular">
              <el-input v-model="model.MobilePhoneNumber"></el-input>
            </el-form-item>

            <el-form-item label="Correo" prop="Email">
              <el-input v-model="model.Email"></el-input>
            </el-form-item>
          </el-card>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
//import { mapGetters } from "vuex";
import Roles from "@/roles";

export default {
  name: "ProspectCreate",
  data() {
    return {
      queryStringObjct: {},
      loading_form: false,
      model: {
        SalesPersonName: this.$store.state.user.user.SalesPersonName,
        CompanyName: "",
        VatRegistrationNumber: "",
        CustomerCode: "",
        Address: "",
        AddressTwo: "",
        City: "",
        FirstName: "",
        MiddleName: "",
        SurName: "",
        JobTitle: "",
        PhoneNumber: "",
        ExtensionNumber: "",
        MobilePhoneNumber: "",
        Email: "",
        Number: "",
        PictureDirectory: "",
        Birthday: "2020-08-13T15:54:09.551Z",
        MagycorpCompanyId: this.$store.state.user.user.CompanySelected,
        SalesPersonCode: this.$store.state.user.user.SalesPersonCode
        //SalesPersonName: this.$store.state.user.user.FullName
        //SalesPersonCode: this.$store.state.user.user.PersonCode
      },
      rules: {
        SalesPersonCode: [
          { required: true, trigger: "blur", message: "Requerido" }
        ],
        FirstName: [{ required: true, trigger: "blur", message: "Requerido" }],
        MiddleName: [{ required: true, trigger: "blur", message: "Requerido" }],
        SurName: [{ required: true, trigger: "blur", message: "Requerido" }],
        JobTitle: [{ required: true, trigger: "blur", message: "Requerido" }],
        PhoneNumber: [
          { required: true, trigger: "blur", message: "Requerido" }
        ],
        MobilePhoneNumber: [
          { required: true, trigger: "blur", message: "Requerido" }
        ],
        Email: [{ required: true, trigger: "blur", message: "Requerido" }],
        VatRegistrationNumber: [
          { required: true, trigger: "blur", message: "Requerido" }
        ],
        CompanyName: [
          { required: true, trigger: "blur", message: "Requerido" }
        ],
        City: [{ required: true, trigger: "blur", message: "Requerido" }],
        Address: [{ required: true, trigger: "blur", message: "Requerido" }]
      },
      sellersList: []
    };
  },
  computed: {
    //...mapGetters({ list_vendors: "sellers/list_to_select" }),

    isVendor() {
      return this.IsInRoles([Roles.SoporteVentas, "all"]);
    }
  },
  mounted() {
    this.list_vendorsV2();
    this.queryStringObjct = this.$route.query;
    this.model.CompanyName =
      this.queryStringObjct != undefined ? this.queryStringObjct.Company : "";

    this.model.PhoneNumber =
      this.queryStringObjct != undefined
        ? this.queryStringObjct.PhoneNumber
        : "";
    this.model.FirstName =
      this.queryStringObjct != undefined ? this.queryStringObjct.FirstName : "";
    this.model.Email =
      this.queryStringObjct != undefined ? this.queryStringObjct.Email : "";
  },
  methods: {
    createContact() {
      this.loading = true;
      this.model.CustomerCode = "";
      this.model.CompanyId = this.currentCompany;
      this.model.LastDateModified = null;
      this.model.Name =
        this.model.FirstName +
        " " +
        this.model.MiddleName +
        " " +
        this.model.SurName;
      {
        this.$http
          .post("/api/contacts", this.model)
          .catch((error) => {
            console.error(error);
            this.$message.error("Error al crear contacto.");
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    updateStatusLeads(statusToUpdate = Boolean) {
      this.$http
        .post("/api/leads/Update", {
          id: this.$route.query.No,
          status: statusToUpdate
        })
        .then(() => {})
        .catch((error) => {
          this.$message.error(
            JSON.parse(error.response.data.Message).Errors[0]
          );
        });
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading_form = true;

          const new_prospect = this.model;
          if (this.isVendor) {
            new_prospect.SalesPersonName = this.currentUser.FullName;
            new_prospect.SalesPersonCode = this.currentUser.PersonCode;
          }

          this.$http
            .post("/api/prospects", new_prospect)
            .then(() => {
              if (this.$route.query.No != undefined) {
                this.updateStatusLeads(true);
              }
              this.createContact();
              this.$router.push({ name: "call-center-prospects-list" });
              this.$message.success("Prospecto creado");
              this.loading_form = false;
            })
            .catch((error) => {
              console.error(error);
              this.$message.error(
                JSON.parse(error.response.data.Message).Errors[0]
              );
              this.loading_form = false;
            });
        } else {
          return false;
        }
      });
    },

    rollback() {
      this.$refs.form.resetFields();
      this.$router.go(-1);
    },
    reset() {
      this.$refs.form.resetFields();
    },

    // TODO: Esto solo se usa con el selector de vendedor
    handleChangeSeller(seller) {
      const vendor = this.sellersList.find((v) => v.SalesPersonCode === seller);
      this.model.SalesPersonName = vendor.FullName;
    },
    list_vendorsV2() {
      this.$http
        .get(`/api/prospects/sellers?company=${this.model.MagycorpCompanyId}`)
        .then((resp) => {
          const sellerMapers = resp.data.map((i) => {
            return {
              SalesPersonCode: i.SalesPersonCode,
              FullName: i.FullName,
              IsEnabled: i.IsEnabled
            };
          });
          this.sellersList = sellerMapers;
        })
        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        });
    }
  }
};
</script>

<style></style>
